"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getBackwardsCompatibleNumberFormat = void 0;
/**
 * There have been issues with some versions of Safari on some operating systems throwing issues with some parameters in the formatOptions.
 *
 * If an error is thrown, we remove some troublesome params from the formatOptions object and fallback to no formatting.
 * This allows us to degrade somewhat gracefully without breaking the dashboard for users of unaffected browsers.
 *
 * For more information, see:
 * - https://www.notion.so/matchwornshirt/Currency-bug-Failed-to-initialize-NumberFormat-d9601f388ee14bdb94ef572e245aa3c8?pvs=4
 * - https://github.com/google/site-kit-wp/issues/3255
 */
var getBackwardsCompatibleNumberFormat = function () {
    var _a;
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    try {
        return new ((_a = Intl.NumberFormat).bind.apply(_a, __spreadArray([void 0], args, false)))();
    }
    catch (error) {
        var locale = args[0], formatOptions = args[1];
        if (!formatOptions)
            return new Intl.NumberFormat(locale);
        // Remove these keys from formatOptions irrespective of value.
        var unstableFormatOptions = ["signDisplay", "compactDisplay"];
        // Remove these key/values from formatOptions.
        var unstableFormatOptionValues = {
            currencyDisplay: "narrowSymbol",
            currencySign: "accounting",
            style: "unit",
        };
        var reducedFormatOptions = {};
        for (var _b = 0, _c = Object.entries(formatOptions); _b < _c.length; _b++) {
            var _d = _c[_b], key = _d[0], value = _d[1];
            if (unstableFormatOptions.includes(key))
                continue;
            if (key in unstableFormatOptionValues &&
                value ===
                    unstableFormatOptionValues[key]) {
                continue;
            }
            reducedFormatOptions[key] = value;
        }
        try {
            return new Intl.NumberFormat(locale, reducedFormatOptions);
        }
        catch (_e) {
            return new Intl.NumberFormat(locale);
        }
    }
};
exports.getBackwardsCompatibleNumberFormat = getBackwardsCompatibleNumberFormat;
